import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import SubscriptionClient from "@/pcm/store/models/SubscriptionClient";

export default class SubscriptionClientSocial extends Model {
    static entity = 'subscription_client_youtube_accounts';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'alias',
    };

    static fields() {
        return {
            id: this.uid(),
            subscription_client_id: this.attr(null),
            alias: this.string(''),
            channel_link: this.string(''),
            channel_id: this.string(''),

            created_at: this.string(''),
            updated_at: this.string(''),

            // Relations
            subscriptionClient: this.belongsTo(SubscriptionClient, 'subscription_client_id'),
        }
    }

    declare id: number;
    declare subscription_client_id: number;
    declare alias: string;
    declare channel_link: string;
    declare channel_id: string;

    declare subscriptionClient: SubscriptionClient | null;
}
